import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal, ChapterLabel } from "./Reveal";
import { site } from "../content";

export const MediaMention = () => {
  const { media } = site;
  return (
    <section id="media" className="py-20 md:py-28" data-testid="media-section">
      <div className="max-w-5xl mx-auto px-6">
        <Reveal>
          <ChapterLabel chapter={media.chapter} label={media.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <a
            href={media.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-8 block rounded-3xl border border-[#EFE6DC] bg-[#FBF8F4] p-8 md:p-12 shadow-[0_8px_30px_rgba(43,39,36,0.04)] hover:shadow-[0_20px_50px_rgba(43,39,36,0.08)] hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
            data-testid="media-article-link"
          >
            <div className="flex items-start justify-between gap-6">
              <div>
                <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#4A6572]">
                  {media.source} · {media.date}
                </p>
                <h3 className="mt-4 font-serif text-2xl md:text-3xl text-[#2B2724] leading-snug max-w-2xl">
                  {media.headline}
                </h3>
                <blockquote className="mt-6 border-l-2 border-[#7C8C7E] pl-5 font-serif italic text-lg md:text-xl text-[#4A6572] leading-relaxed max-w-xl">
                  {media.quote}
                </blockquote>
                <p className="mt-5 text-sm font-medium text-[#7C8C7E] group-hover:text-[#5E6D60] transition-colors duration-200">
                  {media.linkText}
                </p>
              </div>
              <span className="shrink-0 w-11 h-11 rounded-full bg-[#EFE6DC] flex items-center justify-center group-hover:bg-[#7C8C7E] transition-colors duration-300">
                <ArrowUpRight
                  size={20}
                  className="text-[#2B2724] group-hover:text-[#FBF8F4] transition-colors duration-300"
                />
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
